import api from '../config/axiosConfig';
import { API_BASE_URL } from '../utils/constants';
import { Branch, BranchCreate, BranchUpdate, BranchListParams } from '../types/branch';

const API_URL = `${API_BASE_URL}/branches`;

/**
 * Get all branches
 * - Owner sees all branches
 * - Others see only active branches (or only their own)
 */
export const getBranches = async (params?: BranchListParams): Promise<Branch[]> => {
  const response = await api.get<Branch[]>(API_URL, {
    params: { include_inactive: params?.include_inactive || false },
  });
  return response.data;
};

export const getBranchById = async (id: number): Promise<Branch> => {
  const response = await api.get<Branch>(`${API_URL}/${id}`);
  return response.data;
};

export const createBranch = async (branch: BranchCreate): Promise<Branch> => {
  const response = await api.post<Branch>(API_URL, branch);
  return response.data;
};

export const updateBranch = async (
  id: number,
  branch: BranchUpdate
): Promise<Branch> => {
  const response = await api.patch<Branch>(`${API_URL}/${id}`, branch);
  return response.data;
};

export const deleteBranch = async (id: number): Promise<{ message: string }> => {
  const response = await api.delete<{ message: string }>(`${API_URL}/${id}`);
  return response.data;
};
